import React from 'react';
import PoliciesNotesDiffing from '../../../../contracting-reports/diff-report/diffing/policyNotes-content';
import RatePackageDiffing from '../../../../contracting-reports/diff-report/diffing/ratePackage-content';

const SideBySideComparison = props => {
  const { summaryByPage } = props;
  return (
    <div>
      {
        summaryByPage.map(({ header, mainType, pageSections = [], ratePackageId }, index) => {
          return (
            <div
              style={{ marginTop: !index ? `10px` : '20px', fontSize: '14px' }}
            >
              <h4>
                {header}
              </h4>
              <div style={{ padding: '0 36px' }} id={`${header}-body`}>
                {
                  pageSections.map(({ type, label, thisDiffBlock, updateSummary }) => {
                    const PageComponent = mainType === 'policyNotes' ? PoliciesNotesDiffing : RatePackageDiffing;
                    return (
                      <PageComponent
                        key={type}
                        diffBlock={thisDiffBlock}
                        ratePackageId={ratePackageId}
                        updateSummary={updateSummary}
                        type={type}
                        label={label}
                      />
                    );
                  })
                }
              </div>
            </div>);
        })
      }
    </div>
  );
};

export default SideBySideComparison;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/change-log/side-by-side-comparison-modal.js